var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            { attrs: { "vs-align": "left", "vs-w": "6" } },
            [
              _vm.can("create", "campaigns")
                ? _c(
                    "vs-button",
                    {
                      staticClass: "ml-5",
                      attrs: {
                        color: "primary",
                        type: "filled",
                        "icon-pack": "feather",
                        icon: "icon-plus",
                      },
                      on: { click: _vm.showFormCreate },
                    },
                    [
                      _vm._v(
                        "\n                Ajouter une nouveau bloc\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "DialogPrompt",
                {
                  attrs: {
                    active: _vm.showPopup,
                    title: _vm.getDataPrompt.title,
                    "cancel-text": "Annuler",
                    "accept-text": "Enregistrer",
                    "button-accept": _vm.getDataPrompt.btnAccept,
                    "is-valid": !_vm.formError,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.showPopup = $event
                    },
                    cancel: _vm.resetResource,
                    close: _vm.resetResource,
                    accept: _vm.saveResource,
                  },
                },
                [
                  _c("BlocForm", {
                    attrs: { type: _vm.formType },
                    on: { error: _vm.setFormError },
                    model: {
                      value: _vm.resource,
                      callback: function ($$v) {
                        _vm.resource = $$v
                      },
                      expression: "resource",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "DialogPrompt",
                {
                  attrs: {
                    active: _vm.showPopupQuestion,
                    title: _vm.can("update", "questions")
                      ? "Modifier une question"
                      : "Consulter une question",
                    "cancel-text": "Fermer",
                    "accept-text": "Enregistrer",
                    "button-accept": _vm.can("update", "questions")
                      ? "filled"
                      : "false",
                    "is-valid": !_vm.questionFormError,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.showPopupQuestion = $event
                    },
                    cancel: () => (_vm.resourceQuestion = {}),
                    close: () => (_vm.resourceQuestion = {}),
                    accept: _vm.saveQuestion,
                  },
                },
                [
                  _c("QuestionForm", {
                    attrs: {
                      type: _vm.can("update", "questions") ? "update" : "show",
                    },
                    on: { error: (error) => (_vm.questionFormError = error) },
                    model: {
                      value: _vm.resourceQuestion,
                      callback: function ($$v) {
                        _vm.resourceQuestion = $$v
                      },
                      expression: "resourceQuestion",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("vs-col", {
            attrs: { "vs-type": "flex", "vs-align": "left", "vs-w": "6" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vs-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            sst: true,
            search: "",
            "no-data-text": _vm.loading
              ? `Chargement de vos données...`
              : `Aucune donnée à afficher`,
            data: _vm.itemsData,
            loading: true,
          },
          on: { search: _vm.eventSearchItems, sort: _vm.eventSortByCol },
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: {
                        name: "title",
                        value: _vm.apiParams.sortBy.title,
                      },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("\n                    Libellé\n                ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: { name: "type", value: _vm.apiParams.sortBy.type },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("\n                    Type\n                ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: {
                        name: "updated_at",
                        value: _vm.apiParams.sortBy.updated_at,
                      },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [
                      _vm._v(
                        "\n                    Modifier le\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("vs-th", [
                _vm._v("\n                Questions\n            "),
              ]),
              _vm._v(" "),
              _c("vs-th"),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.items.data, function (item, i) {
            return _c(
              "vs-tr",
              { key: i },
              [
                _c("vs-td", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.get(item, ":title")) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("vs-td", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.get(item, ":type")) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("vs-td", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.localeDateTime(_vm.get(item, ":updated_at"))) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "vs-td",
                  _vm._l(_vm.get(item, ":questions"), function (question, i) {
                    return _c(
                      "vs-chip",
                      { key: i, attrs: { color: "primary" } },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              cursor: "pointer !important",
                              "min-height": "26px",
                              "min-width": "26px",
                              "padding-top": "6px",
                            },
                            attrs: { name: "zone" },
                            on: {
                              click: function ($event) {
                                return _vm.showQuestionForm(question)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(question.title) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c("vs-td", { staticClass: "action" }, [
                  _c(
                    "div",
                    { staticClass: "action-wrapper" },
                    [
                      _vm.can("update", "blocs", item.id)
                        ? _c("vs-button", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Modifier",
                                expression: "'Modifier'",
                              },
                            ],
                            attrs: {
                              color: "primary",
                              type: "border",
                              "icon-pack": "feather",
                              icon: "icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.showFormUpdate(item)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.can("delete", "blocs", item.id)
                        ? _c("vs-button", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Supprimer",
                                expression: "'Supprimer'",
                              },
                            ],
                            attrs: {
                              color: "primary",
                              type: "border",
                              "icon-pack": "feather",
                              icon: "icon-trash",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.removeResource(item)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "vs-row",
        [
          _vm.items.total > 0
            ? _c(
                "vs-col",
                { staticClass: "mt-4" },
                [
                  _c("vs-pagination", {
                    attrs: {
                      total: Math.ceil(_vm.items.total / _vm.apiParams.perpage),
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }